import { cn } from '@/lib/utils';
import type { FC, ReactNode } from 'react';

/** The small all-caps label a detail field sits under. */
export const FieldLabel: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => (
    <div className={cn('text-xs font-bold uppercase tracking-wide text-slate-800', className)}>{children}</div>
);

export const DetailItem: FC<{
    label: ReactNode;
    children: ReactNode;
    className?: string;
    valueClassName?: string;
}> = ({ label, children, className, valueClassName }) => (
    <div className={cn('space-y-1', className)}>
        <FieldLabel>{label}</FieldLabel>
        <div className={cn('text-sm font-medium text-foreground', valueClassName)}>{children}</div>
    </div>
);
